<template>
<div class="progress-materializecss" :style="{ opacity: hidden ? '0' : '1'}">
  <div class="indeterminate"></div>
</div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    hidden: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/config.scss';
.progress,
progress[value] {
  width: 100%;
  border: none;
  margin: 0;
  height: 5px;
  display: block;
  appearance: none;
  -webkit-appearance: none;
  &::-webkit-progress-bar {
    background-color: lighten($primaryColor, 35%);
  }
  &::-webkit-progress-value {
    background-color: $primaryColor;
  }
}
.progress-materializecss {
  margin: 5px 0;
  position: relative;
  height: 4px;
  display: block;
  width: 100%;
  background-color: lighten($primaryColor, 35%);
  border-radius: 2px;
  margin: 0;
  overflow: hidden;
  .indeterminate {
    background-color: $primaryColor;
    &:before {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }
    &:after {
      content: '';
      position: absolute;
      background-color: inherit;
      top: 0;
      left: 0;
      bottom: 0;
      will-change: left, right;
      animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      animation-delay: 1.15s;
    }
  }
}
@keyframes indeterminate {
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}
@keyframes indeterminate-short {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ProgressBar.vue